<div class="cf-chart-grid">
  <div class="cf-chart-card">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon">
        <mat-icon>show_chart</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">Ingresos, subvenciones y gastos</p>
        <p class="cf-chart-card__sub">Evolución mensual del ejercicio</p>
      </div>
    </div>

    <div class="cf-chart-canvas-wrap">
      <canvas
        baseChart
        [type]="resumeChartType"
        [data]="resumeChartData"
        [options]="resumeChartOptions"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
      </canvas>
    </div>

    <div class="cf-chart-card__foot" *ngIf="summaryModelRetention">
      <strong style="font-size:12px;letter-spacing:.04em;color:#6b7280;">IMPUESTOS IRPF</strong>
      <table class="tabla-resultados" style="margin-top:10px;">
        <tr>
          <th style="font-weight: bold;">Modelo</th>
          <th>Total</th>
          <th>Pagado</th>
          <th>Diferencia</th>
        </tr>
        <tr *ngFor="let item of summaryModelRetention; trackBy: trackByIndex">
          <td>{{ item.model }}</td>
          <td>{{ item.total | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
          <td>{{ item.totalPaided | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
          <td>{{ item.difference | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
        </tr>
      </table>
    </div>
  </div>

  <div class="cf-chart-card">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon cf-chart-card__icon--green">
        <mat-icon>assessment</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">Resumen del año</p>
        <p class="cf-chart-card__sub">Totales acumulados y rentabilidad</p>
      </div>
    </div>

    <div class="rs-stat-group">
      <div class="rs-stat rs-stat--green" *ngIf="dataV2.incomes?.[12]">
        <span class="rs-stat__label"><mat-icon>arrow_upward</mat-icon> Ingresos</span>
        <span class="rs-stat__value">{{ dataV2.incomes[12].total | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat" *ngIf="dataV2.subventions?.[12]" style="background:rgba(42,120,214,.06);border-color:rgba(42,120,214,.2);">
        <span class="rs-stat__label" style="color:#1e59a8;"><mat-icon>attach_money</mat-icon> Subvenciones</span>
        <span class="rs-stat__value" style="color:#2a78d6;">{{ dataV2.subventions[12].total | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat rs-stat--red" *ngIf="dataV2.expenses?.[12]">
        <span class="rs-stat__label"><mat-icon>arrow_downward</mat-icon> Gastos</span>
        <span class="rs-stat__value">{{ dataV2.expenses[12].total | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat rs-stat--total">
        <span class="rs-stat__label">Balance</span>
        <span class="rs-stat__value">{{ totalBalance | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat rs-stat--total" *ngIf="dataV2.incomes?.[12] && dataV2.expenses?.[12]">
        <span class="rs-stat__label">% Rentabilidad</span>
        <span class="rs-stat__value">{{ percentageOfSalesProfitability(dataV2.incomes[12].total, dataV2.expenses[12].total) | number:'1.1-1' }} %</span>
      </div>
    </div>

    <div style="display:flex;gap:10px;margin-top:16px;flex-wrap:wrap;">
      <button mat-stroked-button style="flex:1;min-width:180px;" (click)="openDialogBalance()">
        <mat-icon>account_balance</mat-icon>
        Balance Sumas y Saldos
      </button>
      <button mat-stroked-button style="flex:1;min-width:180px;" (click)="redirectCashFlow()">
        <mat-icon>trending_up</mat-icon>
        Flujo de caja
      </button>
    </div>

    <div class="cf-chart-card__foot">
      <div class="rs-stat-group">
        <div class="rs-stat" style="background:#f9fafb;">
          <span class="rs-stat__label">Ventas hoy</span>
          <span class="rs-stat__value">{{ resumeToday.generalIncomes | number:'1.2-2' }} €</span>
        </div>
        <div class="rs-stat" style="background:#f9fafb;">
          <span class="rs-stat__label">Gastos hoy</span>
          <span class="rs-stat__value">{{ resumeToday.generalExpenses | number:'1.2-2' }} €</span>
        </div>
        <div class="rs-stat" style="background:#f9fafb;">
          <span class="rs-stat__label">Diferencia</span>
          <span class="rs-stat__value">{{ resumeToday.generalBalance | number:'1.2-2' }} €</span>
        </div>
      </div>
    </div>
  </div>
  <div class="cf-chart-card cf-chart-card--accounts">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon cf-chart-card__icon--green">
        <mat-icon>insert_chart</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">Tus cuentas claras</p>
        <p class="cf-chart-card__sub">Desglose de tu resultado</p>
      </div>
    </div>

    <ng-container *ngIf="businessAnalysis == null && !businessAnalysisError">
      <div class="container text-center" style="margin-top:15px;"><div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div></div>
    </ng-container>

    <ng-container *ngIf="businessAnalysisError">
      <p style="color: #8f9493; font-size: 0.85em; padding: 8px 0;">No hay datos de análisis disponibles para el período seleccionado.</p>
    </ng-container>

    <ng-container *ngIf="businessAnalysis != null">
      <div class="table-responsive">
        <table class="tabla-resultados table" style="font-size:12px;">
          <thead>
            <tr>
              <th style="text-align:center;">Categoría</th>
              <th style="text-align:center;">Descripción</th>
              <th style="text-align:center;">Importe</th>
              <th style="text-align:center;">%</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="text-align:center;">Tus ingresos</td>
              <td style="color:#888;font-size:11px;text-align:center;">Todo el dinero que entra por tu actividad</td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
              <td style="text-align:center;">100%</td>
            </tr>
            <tr>
              <td style="text-align:center;">Tus costes para conseguir ingresos</td>
              <td style="color:#888;font-size:11px;text-align:center;">Gastos operativos del día a día</td>
              <td style="text-align:center;">{{ businessAnalysis.costesIngresos | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos > 0 ? (businessAnalysis.costesIngresos / businessAnalysis.ingresos | percent:'1.1-1') : '—' }}</td>
            </tr>
            <tr style="font-weight:bold;background:#f5f5f5;">
              <td colspan="2" style="text-align:center;">Resultado operativo</td>
              <td style="text-align:center;">{{ businessAnalysis.resultadoOperativo | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos > 0 ? (businessAnalysis.resultadoOperativo / businessAnalysis.ingresos | percent:'1.1-1') : '—' }}</td>
            </tr>
            <tr>
              <td style="text-align:center;">Los costes de tu estructura</td>
              <td style="color:#888;font-size:11px;text-align:center;">Gastos para mantener la actividad</td>
              <td style="text-align:center;">{{ businessAnalysis.costesEstructura | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos > 0 ? (businessAnalysis.costesEstructura / businessAnalysis.ingresos | percent:'1.1-1') : '—' }}</td>
            </tr>
            <tr>
              <td style="text-align:center;">Costes financieros</td>
              <td style="color:#888;font-size:11px;text-align:center;">Intereses, préstamos y comisiones bancarias</td>
              <td style="text-align:center;">{{ businessAnalysis.costesFinancieros | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos > 0 ? (businessAnalysis.costesFinancieros / businessAnalysis.ingresos | percent:'1.1-1') : '—' }}</td>
            </tr>
            <tr>
              <td style="text-align:center;">Amortización</td>
              <td style="color:#888;font-size:11px;text-align:center;">Coste del desgaste de equipos e inversiones</td>
              <td style="text-align:center;">{{ businessAnalysis.amortizacion | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos > 0 ? (businessAnalysis.amortizacion / businessAnalysis.ingresos | percent:'1.1-1') : '—' }}</td>
            </tr>
            <tr style="font-weight:bold;background:#f5f5f5;">
              <td colspan="2" style="text-align:center;">Resultado Antes de Impuestos</td>
              <td style="text-align:center;" [style.color]="businessAnalysis.resultadoAntesDeImpuestos >= 0 ? '#2e7d32' : '#c62828'">
                {{ businessAnalysis.resultadoAntesDeImpuestos | currency:'EUR':'symbol':'1.2-2':'es' }}
              </td>
              <td style="text-align:center;">{{ businessAnalysis.ingresos > 0 ? (businessAnalysis.resultadoAntesDeImpuestos / businessAnalysis.ingresos | percent:'1.1-1') : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>
